import { NavLink } from "react-router-dom";
import { paths } from "routes/paths";
import i18n from "i18next";
import { toast } from "sonner";

export const GlobalErrorHandler = (error: any) => {
  if (
    error?.status === 403 &&
    error?.data?.message === "Access Error!" &&
    !!localStorage.getItem("token")
  ) {
    toast.error(i18n.t("general.messages.accessError"), {
      action: <NavLink to={paths.auth.login} />,
    });
  } else {
    toast.error("مشکلی در ارتباط با سرور پیش آمده است");
  }
  console.error(error);
};
